var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "more"
  }, [_c('Card', {
    staticClass: "more-app",
    nativeOn: {
      "click": function ($event) {
        return _vm.jump.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-list"
  }, [_c('Icon', {
    staticClass: "card-icon",
    attrs: {
      "type": "ios-add-circle-outline"
    }
  }), _c('h3', [_vm._v($t("cf26q44", "应用市场"))])], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };